var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slide',{attrs:{"left":"","closeOnNavigation":true,"noOverlay":""}},[_c('a',{staticClass:"sidenav_link"},[_c('span',[_vm._v("Promoções")])]),_vm._v(" "),_c('a',{staticClass:"sidenav_link"},[_c('span',[_vm._v("Minha Conta")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eaa16b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidenavResponsivo.vue
// module id = null
// module chunks = 